import Page from "components/Page";
import React, { useEffect, useState } from "react";
import styles from "./../../../ManageSystemInstructions/SystemInstruction.module.scss";
import { withTranslation } from "react-i18next";
import constants from "./../../../../../../constants";
import Card from "components/Card";
import Input from "components/Input";
import { decodeId, testRegexCheck, testRegexCheckDescription } from "utils";
import { cloneDeep } from "lodash";
import {
  useAddPrompt,
  useUpdatePrompt,
} from "repositories/ai-assistant-repository";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

function AddEditPrompt({ history, t, location }) {
  let { promptId } = useParams();
  promptId = decodeId(promptId);

  const [formData, setFormData] = useState({
    promptName: "",
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const useAddPromptMutation = useAddPrompt();
  const useUpdatePromptMutation = useUpdatePrompt();

  useEffect(() => {
    if (promptId) {
      setFormData({
        promptName: location?.state?.selectedData?.promptName || "",
        description: location?.state?.selectedData?.description || "",
      });
    }
  }, [promptId]);

  const goBack = () =>
    history.push({ pathname: constants.routes.aiAssistant.managePrompts });

  const handlePromptNameChange = (e) => {
    setFormData({
      ...formData,
      promptName: e.target.value,
    });
  };

  const handleDescriptionChange = (e) => {
    setFormData({
      ...formData,
      description: e.target.value,
    });
  };

  const isValidEvent = () => {
    const errorsData = cloneDeep(errors);

    const promptNameValue = formData?.promptName || "";
    if (!promptNameValue.toString().trim().length) {
      errorsData.promptName = t("form.errors.emptyField", {
        field: t("aiAssistant.addPrompt.promptName"),
      });
    } else {
      delete errorsData.promptName;
    }

    const descriptionValue = formData?.description || "";
    if (!descriptionValue.toString().trim().length) {
      errorsData.description = t("form.errors.emptyField", {
        field: t("aiAssistant.addPrompt.describePrompt"),
      });
    } else {
      delete errorsData.description;
    }

    setErrors(errorsData);
    return !Object.values(errorsData).some((err) => !!err);
  };

  const saveUpdatePrompt = async () => {
    if (!isValidEvent()) return;
    setShowLoader(true);

    try {
      const params = {
        promptName: formData?.promptName,
        description: formData?.description,
      };

      if (promptId) params.id = promptId;

      const resp = promptId
        ? await useUpdatePromptMutation.mutateAsync(params)
        : await useAddPromptMutation.mutateAsync(params);

      toast.success(resp?.message);
      goBack();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <>
      <Page
        onBack={() => goBack()}
        className={styles["global-main-page"]}
        title={
          promptId
            ? t("aiAssistant.addPrompt.editPrmopt")
            : t("aiAssistant.addPrompt.heading")
        }
      >
        <div className={styles["new-instruction-messages"]}>
          <Card radius="10px" className={styles["instruction-card"]}>
            <div className={styles["input-wrapper"]}>
              <Input
                Title={t("aiAssistant.addPrompt.promptName")}
                Type="text"
                Placeholder="Enter"
                Name="promptName"
                HandleChange={handlePromptNameChange}
                Error={
                  !formData?.promptName && errors.promptName
                    ? errors.promptName
                    : ""
                }
                Value={formData?.promptName || ""}
              />
              <div className="c-field">
                <label>{t("aiAssistant.addPrompt.describePrompt")}</label>
                <textarea
                  className="c-form-control"
                  name="description"
                  maxLength="500"
                  placeholder="Enter"
                  onChange={handleDescriptionChange}
                  value={formData?.description || ""}
                ></textarea>
                {!formData?.description && errors.description && (
                  <span className="error-msg">{errors.description}</span>
                )}
                <span className={styles["character-limit-msg"]}>
                  {t("aiAssistant.addPrompt.characterLimit")}
                </span>
              </div>

              <button
                className="button  button-round button-shadow mr-3"
                onClick={() => saveUpdatePrompt()}
                disabled={showLoader}
              >
                {promptId ? t("update") : t("save")}
              </button>
              <button
                className="button  button-round  button-border button-dark"
                onClick={() => goBack()}
              >
                {t("cancel")}
              </button>
            </div>
          </Card>
        </div>
      </Page>
    </>
  );
}

export default withTranslation()(AddEditPrompt);
